<style lang="scss" scoped>
.panel {
	&__flag {
		margin-right: 15px;
		position: relative;
		margin-top: -2px;
	}
}
</style>

<template lang="pug">
	el-card.panel(v-if="school")
		table.data
			tr
				td Installed
				td {{ school.installed | boolean }}
			tr
				td Shard region
				td {{ school.shard_region_code || "N/A" }}
			tr
				td Online
				td {{ school.online | boolean }}
			tr
				td MIS/SIS
				td {{ school.installed ? school.mis_name : "N/A" }}
			tr(v-if="school.uses_wonde_client")
				td Last heartbeat
				td {{ school.last_heartbeat_at | time_ago }}
			tr(v-if="school.uses_wonde_client && school.app_version")
				td App version
				td(@click="openVersionsTable()") {{ school.app_version }} 
					i.fe.fe-external-link
			tr
				td Approved Companies
				td {{ companiesApprovedForSchool || '-' }}
</template>

<script>
import CompaniesQuery from "@/graphql/queries/UserCompanies";
import WondeClientReleases from "@/components/modals/WondeClientReleases";

export default {
	props: {
		school: {
			required: true,
			type: Object
		}
	},
	methods: {
		openVersionsTable() {
			this.$vuedals.open({
				title: "Wonde client releases",
				component: WondeClientReleases,
				props: {
					release: this.school.app_version
				}
			});
		}
	},
	computed: {
		companiesApprovedForSchool() {
			if (!this.UserCompanies || !this.UserCompanies.length) {
				return "-";
			}
			return this.school.State.filter(state => state.state == "approved")
				.filter(s => this.UserCompanies.map(c => c.id).includes(s.Company.id))
				.map(s => s.Company.name)
				.join(", ");
		}
	},
	apollo: {
		UserCompanies: {
			query: CompaniesQuery,
			update(r) {
				return r.User.Companies;
			}
		}
	}
};
</script>
